
  import { PrivateForm, tools } from '@wenjuan/business'
  import { mapMutations } from 'vuex'
  import FixedService from '../home/fixed-service.vue'
  import { createObserver, getElemPos } from '~/utils/tools.js'
  import { httpMemberPackageInfo, getUserInfo, bindingSaler } from '~/api/common.js'
  import $WATCH from '~/api/watch-pipe.js'
  import { featureGroups, packagePricingPlans } from '~/components/senior-user/package-pricing.js'

  export default {
    name: 'SeniorDemo',
    components: {
      PrivateForm,
      FixedService,
    },
    layout: 'template-page',
    data() {
      return {
        featureGroups,
        packagePricingPlans,
        currentVersionPackage: {
          advance_version: 'year', // month/year
          enterprise_version: 'year',
        },
        showPrivateForm: false, // 显示部署版登记弹窗
        showConsultDialog: false, // 显示咨询顾问弹窗
        lowestVersionStr: 'advance_version',
        activeVersionStr: 'advance_version',
        useBack: false,
        memberPKGInfo: {}, // 当前用户套餐信息
        intersections: {
          top: '',
          body: '',
          end: '',
        },
        hasBindMobile: true,
        stripe: ['odd', 'even'],
        qaList: [
          [
            'Q1. 问卷网可以使用哪些场景和题型？',
            '问卷网现提供问卷调查、满意度调查、投票评选、报名登记表、在线收款、考试测评等场景。题型涵盖单选/多选题、图片选择/上传题、投票题、填空题、打分题、地理位置题等40多种题型。',
          ],
          [
            'Q2. 如何确保数据存储安全性？',
            '问卷网始终将数据安全放在第一位。我们对系统部署了完善的加密功能，使用Https加密协议，并通过了三级等保认证，保证数据在传输过程中绝对安全。同时在服务器端配置有完善的数据备份方案，让您安心使用无后顾之忧。',
          ],
          [
            'Q3. 如何支付并购买套餐？',
            '问卷网为您开通了微信支付和支付宝支付两种在线支付方式。同时我们还提供了线下支付，进入“我的账户-我的钱包”，选择“银行转账”后根据转账提示完成转账。我们将在工作日的24h内为您的账户充值，您可使用账户余额购买套餐。',
          ],
          [
            'Q4.购买后，是否可开具发票？',
            `我们提供在线申请发票的功能，您只需填写发票信息和收件人信息，我们打印完成后会通过快递寄送给您。 点击 <a href="/m/help/detail/56a5f21da320fc6ab839e110">查看发票申请方法</a>`,
          ],
        ],
        showTxt: true,
        sale: false,
      }
    },
    fetchOnServer: false,
    async fetch() {
      try {
        const { data } = await getUserInfo()
        this.$store.commit('setLoginStatus', { loggedIn: 1 })
        this.hasBindMobile = !!data?.mobile
        if (this.loggedIn && !data.custom_attr.channel_code && this.$route.query.channel_code) {
          console.log('已登陆且未绑定销售且是销售链接')
          await bindingSaler({ channel_code: this.$route.query.channel_code })
        }
        const res = await httpMemberPackageInfo({ is_get_personal_package_info: 1 })
        if (res.status_code === 1) {
          this.memberPKGInfo = res.data
          // 存储购买弹窗接口的存储数据
          this.$store.commit('member/setPackageInfo', res.data)

          // 如果存在sessionStorage中的version，则购买套餐
          if (this.loggedIn && sessionStorage && sessionStorage.getItem('version')) {
            this.handleBuy(sessionStorage.getItem('version'))
            sessionStorage.removeItem('version')
          }
        }
      } catch (e) {
        console.log(e, 'featch请求错误')
      }
    },
    head: {
      title: '问卷网_免费版、高级版、定制版的区别',
      link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/senior_user/' }],
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '免费版，高级版，定制版，调查问卷，问卷调查，问卷网',
        },
        {
          hid: 'description',
          name: 'description',
          content: '问卷网，免费专业的在线调研、报名表单、考试测评平台。用户可查看问卷网免费版、高级版、定制版的区别。',
        },
      ],
      script: [{ src: '//s1.wenjuan.com/lib/jquery/1.8.3/jquery.min.js' }],
    },
    computed: {
      microAppInfo() {
        return tools.$ENV.defineState()
      },
      loggedIn() {
        return this.$store.state.loginStatus.loggedIn == 1
      },
      version() {
        return this.memberPKGInfo.package_status ? this.memberPKGInfo.package_status.version : 'free'
      },
      packageList() {
        const list = Object.keys(packagePricingPlans).map((key) => {
          const item = packagePricingPlans[key]
          const { name, icon, description, paymentTypes, price: priceObj, features } = item
          const {
            unit,
            value: priceValue,
            priceText = '',
            features: paymentFeatures = {},
          } = priceObj || paymentTypes[this.currentVersionPackage[key]]

          const priceFormatter = new Intl.NumberFormat('en-US')
          const price = !unit ? priceValue : `${unit}${priceFormatter.format(priceValue)}`
          const period = key === 'free' ? '' : this.currentVersionPackage[key] === 'month' ? '月' : '年'

          return {
            id: key,
            name,
            icon,
            description,
            price,
            priceText,
            period,
            features: {
              ...features,
              ...paymentFeatures,
            },
          }
        })
        return list
      },
    },
    mounted() {
      console.log(this.packageList)
      $WATCH.on('headerEndFetchUserInfo', () => {
        if (this.loggedIn && sessionStorage && sessionStorage.getItem('tryApply')) {
          this.tryApply()
        }
      })
      const preLoad = window.onload
      window.onload = () => {
        preLoad && preLoad()
        this.$nextTick(() => {
          this.setHightLightHeader({
            active: 'senior_user',
          })
          const VM = this.$refs['watch-line']
          const watchEnd = this.$refs['watch-end']
          VM &&
            watchEnd &&
            createObserver({
              threshold: [0, 0.1, 0.2, 0.9, 1],
            })
              .add(VM)
              .then((status) => {
                this.useBack = !status
                this.showTxt = status
              })
              .add(watchEnd)
              .then((status, { boundingClientRect: { bottom } }) => {
                if (!status && this.useBack && !this.showTxt && bottom < 300) this.useBack = false
                if (status && !this.useBack) this.useBack = true
              })
        })
      }
      if (this.$route.query.channel_code) {
        this.sale = true
        document.getElementsByClassName('header-wrap')[0].style.display = 'none'
        document.getElementById('common-footer').style.display = 'none'
        this.$refs.wrapper.style.display = 'none'
        document.getElementsByClassName('dome-body_foot')[0].style.display = 'none'
      }
    },
    methods: {
      ...mapMutations(['setHightLightHeader']),
      handleBuy(ver) {
        if (!this.loggedIn) {
          this.$store.commit('setLoginStatus', {
            show: true,
            nextUrl: () => {
              sessionStorage && sessionStorage.setItem('version', ver)
              window.location.reload()
            },
          })
          return
        }
        const versionList = ['free', 'advance_version', 'enterprise_version', 'enterprise_ultimate_version']

        // 判断购买的套餐版本是否低于现有套餐版本，若低于则提示
        if (versionList.indexOf(ver) < versionList.indexOf(this.version)) {
          this.$message2.warning('不可以购买低于现有套餐版本的套餐，请重新选择套餐')
          return
        }

        // 显示最低版本为当前版本的下一级，若为旗舰版则只显示旗舰版
        const index = versionList.indexOf(this.version) === 3 ? 3 : versionList.indexOf(this.version) + 1
        this.lowestVersionStr = this.microAppInfo.isFreeTry ? 'advance_version' : versionList[index]
        // 高亮版本为点击版本
        this.activeVersionStr = ver
        // 显示新版购买弹窗
        this.openPackageDialog()
      },
      addRegister() {
        if (!this.loggedIn) {
          this.$store.commit('setLoginStatus', {
            show: true,
            nextUrl: () => {
              sessionStorage && sessionStorage.setItem('openPrivateForm', '1')
              window.location.reload()
            },
          })
        } else {
          this.showPrivateForm = false
          this.showConsultDialog = true
          sessionStorage.removeItem('openPrivateForm')
        }
      },
      enter() {
        if (!this.loggedIn) {
          this.$store.commit('setLoginStatus', {
            show: true,
            nextUrl: async () => {
              if (this.$route.query.channel_code) {
                await bindingSaler({ channel_code: this.$route.query.channel_code })
              }
              this.$href('/list')
            },
          })
        } else {
          this.$href('/list')
        }
      },
      tryApply() {
        if (!this.loggedIn) {
          this.$store.commit('setLoginStatus', {
            show: true,
            nextUrl: () => {
              sessionStorage && sessionStorage.setItem('tryApply', '1')
              window.location.reload()
            },
          })
        } else {
          // window.location.href = '/list/'
          this.$href('/s/UZBZJvX9GO6/#')
          sessionStorage.removeItem('tryApply')
        }
      },
      // 购买支付结束
      payCompleted(result) {
        if (result) {
          // 刷新页面
          window.location.reload()
        }
      },
      // isShowPrivateForm() {
      //   if (this.loggedIn && sessionStorage && sessionStorage.getItem('openPrivateForm')) {
      //     this.showPrivateForm = true
      //     sessionStorage.removeItem('openPrivateForm')
      //     return
      //   }

      //   const hash = window.location.hash
      //   if (hash === '#private') {
      //     this.gotoWrapper()
      //     this.addRegister()
      //   }
      // },
      // 滚动到广告投放标签 ref=wrapper
      gotoWrapper() {
        const yPos = getElemPos(this.$refs.wrapper).y
        document.body.scrollTop = document.documentElement.scrollTop = yPos - 100
      },
      // 打开购买弹窗
      openPackageDialog() {
        // 混乱的弹窗模式， 10月需要修复
        this.$store.commit('setPackageDialog', {
          show: true,
          lowestVersion: this.lowestVersionStr,
          activeVersion: this.activeVersionStr,
          initPeriod: this.currentVersionPackage[this.activeVersionStr] === 'month' ? 31 : 365,
          source: '套餐页面',
          on: {
            payment: this.payCompleted,
          },
        })
      },
      handleChangePeriod(period, version) {
        this.currentVersionPackage[version] = period
      },
      // 格式化功能值显示
      formatFeatureValue(feature, type) {
        console.log('-------------', JSON.stringify(feature), feature.text, type)
        if (!feature.available) return '-'
        switch (type) {
          case 'check':
            return '✓'
          case 'number':
            return `${feature.value}${feature.unit || ''}`
          case 'size':
            return feature.value ? `最大${feature.value}${feature.unit}` : '-'
          case 'quota':
            return `${feature.value}${feature.unit || ''}`
          case 'protocol':
            return `支持${feature.value}`
          case 'text':
            return feature.value
          default:
            return feature.value || '✓'
        }
      },
    },
  }
